<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function () {
    // Select the legend element with the class 'form__label'
    const legendLabel = document.querySelector('legend.form__label');

    // Replace the text "Farbe" with "Color"
    if (legendLabel && legendLabel.textContent.includes("Farbe")) {
        legendLabel.innerHTML = legendLabel.innerHTML.replace("Farbe:", "Color:");
    }
});
document.addEventListener("DOMContentLoaded", function () {
    // Select the legend element with the class 'form__label' for "Größe"
    const legendLabels = document.querySelectorAll('legend.form__label');

    // Iterate through all legend elements to find and replace "Größe"
    legendLabels.forEach((label) => {
        if (label.textContent.includes("Größe")) {
            label.innerHTML = label.innerHTML.replace("Größe:", "Size:");
        }
    });
});

